import { apiPost } from "../utils/api";

export const attachPolicy = async () => {
    return await apiPost('authentication/attach-policy').then(async result => {
        //console.log('Added IOT Policy', result);
    });
};